export * from './app-sidebar.component';



// WEBPACK FOOTER //
// ./src/app/components/app-sidebar/index.ts